import { Stack } from '@mantine/core'
import React, { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import useLocalStorage from '@/hooks/useLocalStorage'
import useProfilePath from '@/hooks/useProfilePath'
import { getDefaultProfileImage } from '@/plugins/auth/AuthProvider/effects/functions'

import { CreatorProfile, StoredTheme } from '../../utils/utils'
import UserDetails from '../Details/UserDetails/UserDetails'
import itemCardClasses from '../Items/ItemsCard.module.css'
import Loading from '../Loading'
import ImageWrapper from '../MediaWrappers/ImageWrapper'
import classes from './CreatorsCard.module.css'

interface CreatorsCardProps {
  elem: CreatorProfile
  imageSize?: number
}

const CreatorsCard: React.FC<CreatorsCardProps> = ({ elem, imageSize = 180 }) => {
  const navigate = useNavigate()
  // default profile images
  const [userTheme] = useLocalStorage<StoredTheme>('userTheme')
  const defaultPfp = useMemo(() => getDefaultProfileImage(userTheme?.isLightMode), [userTheme])
  const profilePath = useProfilePath(elem.address as `0x${string}`)

  const handleNavigation = useCallback(() => {
    if (elem) {
      navigate(profilePath)
    }
  }, [elem])

  return (
    <Stack
      style={{ gap: '15px', cursor: 'pointer' }}
      onClick={handleNavigation}
      className={itemCardClasses.card}
    >
      {elem ? (
        <ImageWrapper
          src={elem.profile.image || defaultPfp}
          alt={elem.profile.name}
          className={classes.image}
          style={{
            width: `${imageSize}px`,
            height: `${imageSize}px`,
            bottom: 0,
            left: '10px',
          }}
          width={imageSize}
          height={imageSize}
        />
      ) : (
        <Loading size={`${imageSize}px`} />
      )}

      {elem && elem?.profile?.name && (
        <Stack
          style={{ alignSelf: 'left', gap: 0, width: `${imageSize}px` }}
          className={itemCardClasses.blockText}
        >
          <UserDetails userId={elem.address} hidePfp hideUsername width={`${imageSize}px`} />
        </Stack>
      )}
    </Stack>
  )
}

export default CreatorsCard
